import React from 'react';
import Suspense from '../../Common/components/Suspense-component';

import AddPharmacy from '../component-add-pharmacy';
import { getNationalHolidays } from '../epics-pharmacies';
import { prepareHolidays } from '../../Common/Helpers';

export default class AddPharmacyPage extends React.Component {

    getNationalHolidays = () => {
        return getNationalHolidays().then(repsonse => {
            return prepareHolidays(repsonse);
        });
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    nationalHolidays: this.getNationalHolidays
                }}
            >
                <AddPharmacy />
            </Suspense>
        );
    }
}


// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/containers/container-add-pharmacy.js